import { unsafeCSS } from 'lit';
import fillHeightTableStylesText from './fill-height-table.css?inline';
import fillHeightHostStylesText from './fill-height-host.css?inline';

/**
 * Thin barrel over the sibling stylesheets.
 *
 * One .css per export: the sheets are applied independently by different
 * components, so keeping them separate is what lets a consumer take one
 * without the other. Exported names are unchanged, so no consumer edits.
 */
export const fillHeightTableStyles = unsafeCSS(fillHeightTableStylesText);

export const fillHeightHostStyles = unsafeCSS(fillHeightHostStylesText);
